import { useRouter } from '@application/utils';
import { Button } from '@presentation/components';
import type { FC } from 'react';
import { useState } from 'react';
import { TbArrowRight } from 'react-icons/tb';
import * as Styled from './styled';
import type { FeatureListProps } from './types';

// Make this global if used anywhere else
export const FeatureList: FC<FeatureListProps> = (props) => {
  const { language } = useRouter();
  const { items } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <Styled.Wrapper>
      <Styled.Nav>
        {items.map((item, index) => (
          <Button
            key={index}
            color={activeIndex === index ? 'blue' : 'transparent'}
            onClick={() => setActiveIndex(index)}
            size="large"
            shrink
            iconRight={<TbArrowRight />}
          >
            {item.title}
          </Button>
        ))}
      </Styled.Nav>

      <Styled.Content>
        <Styled.ContentText>{items[activeIndex].text}</Styled.ContentText>
        <Styled.ContentImage>
          <picture>
            <source
              media="(min-width: 1200px)"
              srcSet={items[activeIndex].image[language as 'fr' | 'de' | 'nl'][0]}
            />
            <img src={items[activeIndex].image[language as 'fr' | 'de' | 'nl'][1]} alt="" />
          </picture>
        </Styled.ContentImage>
      </Styled.Content>
    </Styled.Wrapper>
  );
};
